"use client";

import { RefObject } from "react";
import { Countdown } from "./countdown";

type Props = {
  videoPreviewRef: RefObject<HTMLVideoElement | null>;
  showCountdown: boolean;
  countdownCount: number | null;
  isRecording: boolean;
  recordingDuration: number;
  shouldMirror?: boolean;
};

/**
 * Camera preview player for video recording with countdown overlay and recording indicator.
 */
export const CreatorCameraPlayer = ({
  videoPreviewRef,
  showCountdown,
  countdownCount,
  isRecording,
  recordingDuration,
  shouldMirror = true,
}: Props) => (
  <div className="relative flex flex-1 items-center justify-center overflow-hidden bg-black">
    <div className="flex aspect-[9/16] h-full max-h-full w-auto items-center justify-center">
      <video
        ref={videoPreviewRef}
        autoPlay
        playsInline
        muted
        className="h-full w-full rounded-3xl object-contain"
        style={shouldMirror ? { transform: "scaleX(-1)" } : undefined}
        aria-label="Camera preview"
      />
    </div>

    {/* Countdown Overlay */}
    {showCountdown && countdownCount !== null && (
      <Countdown count={countdownCount} />
    )}

    {/* Recording Indicator */}
    {isRecording && (
      <div className="absolute bottom-1.25 flex w-full justify-center">
        <div className="flex w-fit items-center gap-2 rounded-full bg-pink-500 px-2 py-1">
          <span className="text-lg leading-3 font-semibold text-white">
            {/* Count from 30 seconds to 0 in MM:SS format */}
            {(() => {
              const remainingSeconds = Math.max(
                0,
                Math.ceil((30000 - recordingDuration) / 1000),
              );
              const minutes = Math.floor(remainingSeconds / 60);
              const seconds = remainingSeconds % 60;
              return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
            })()}
          </span>
        </div>
      </div>
    )}
  </div>
);
